import React, { FC } from 'react';
import { FormattedMessage } from 'react-intl';
import { IOuter } from '../EmptyState.types';

export const FavoritesTitle: FC<IOuter> = () => <FormattedMessage id="empty-state.favorites-title" />;
